import React from "react";
import { useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import Table from "../Table/Table";

const OBJ_TABLE = {
  "Club Name": "clubName",
  Role: "role",
  Status: "status",
  "Added At": "addedAt",
};

const ViewAll = ({ userData }) => {

  const page = 1
  const perPage = 0;
  const totalDocuments = 10;
  const currentSort = {
    sortBy: "registered on",
    order: "desc",
  }
  const { records_per_page } = useSelector((state) => state.setting);


  if (userData.length > 0) {
    return (
      <div className="dataTables_wrapper ">
        <Table
          currentSort={currentSort}
          mainData={userData}
          tableHeading={Object.keys(OBJ_TABLE)}
          tableData={Object.values(OBJ_TABLE)}
          onlyDate={{
            createdAt: "date",
            startDate: "dateTime",
            endDate: "dateTime",
            addedAt: "dateTime",
          }}
        />

        {perPage !== 0 && (
          <Pagination
            page={page}
            totalDocuments={totalDocuments}
            perPage={perPage}
            defaultPerPage={records_per_page}
          />
        )}
      </div>
    );
  }

  return "No Roles Found";

};

export default ViewAll;
